import scanPage from './view/scanModal.html'

export default class ListCtrl {
    constructor($scope, httpRequest, logger, $state, sweetalert, $uibModal) {
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            total: 10,
            param: {
                type: '0',
                contractNo: '', // 单据编号 ,
                contractType: '', // 合同类型（即合同模板名中业务名称）,
                createUser: '', // 创建用户(扫描人) ,
                startTime: '', // 开始时间 ,
                endTime: '', // 结束时间 ,
            },
        }
        $scope.reset = function reset() {
            $scope.queryParam.param = {
                type: '0',
                contractNo: '', // 单据编号 ,
                contractType: '', // 合同类型（即合同模板名中业务名称）,
                createUser: '', // 创建用户(扫描人) ,
                startTime: '', // 开始时间 ,
                endTime: '', // 结束时间 ,
            }
        }
        // $scope.reset()
        $scope.contractTemplates = []
        // let isSearch = false
        // $scope.$watch('queryParam', () => {
        //     isSearch = false
        // }, true)
        // $scope.$on('$stateChangeStart', (e, toState) => {
        //     if (toState.name.indexOf('input.electronImage.contractEntering') != -1) {
        //         isSearch && sessionStorage.setItem('contractEnterParam', JSON.stringify($scope.queryParam))
        //     }
        // })
        $scope.queryList = function queryList() {
            $scope.queryParam = sessionStorage.contractEnterParam ? JSON.parse(sessionStorage.contractEnterParam) : $scope.queryParam
            httpRequest.post_getIvatContractList($scope.queryParam).then((res) => {
                $scope.contractList = res.data.value.list
                $scope.queryParam.total = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
            })
        }
        $scope.searchList = function () {
            sessionStorage.setItem('contractEnterParam', JSON.stringify($scope.queryParam))
            $scope.queryList()
        }
        // 分页
        $scope.pageChanged = function () { // 点击页码发起查询
            sessionStorage.setItem('contractEnterParam', JSON.stringify(
                {
                    pageNum: $scope.queryParam.pageNum,
                    pageSize: $scope.queryParam.pageSize,
                    param: sessionStorage.contractEnterParam ? JSON.parse(sessionStorage.contractEnterParam).param : {
                        type: '0',
                        contractNo: '', // 单据编号 ,
                        contractType: '', // 合同类型（即合同模板名中业务名称）,
                        createUser: '', // 创建用户(扫描人) ,
                        startTime: '', // 开始时间 ,
                        endTime: '', // 结束时间 ,
                    },
                },
            ))
            $scope.queryList()
        }
        $scope.openScanDialog = function openScanDialog() {
            return $uibModal.open({
                template: scanPage,
                controller: 'contractScanCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-xs',
                resolve: {
                    contractTemplates() {
                        return $scope.scanTemplates
                    },
                },
            }).result.then(() => {
                $scope.queryList()
            })
        }

        function getContractTypeList() {
            httpRequest.post_getContractTemplateList({
                pageNum: 1,
                pageSize: 100000,
                param: {
                },
            }).then((res) => {
                $scope.contractTemplates = res.data.value.list
                $scope.scanTemplates = $scope.contractTemplates.filter((template) => template.status === '1')
            })
        }

        function init() {
            getContractTypeList()
            $scope.queryList()
        }
        init()
        $scope.tableDropdownConfig = [
            {
                label: '编辑',
                handler(item) {
                    $state.go('input.electronImage.contractEntering.edit', { contractId: item.contractId })
                },
            },
            {
                label: '提交',
                handler(item) {
                    let msg
                    // 还有查验未通过的发票信息
                    if (item.invoiceNum === item.checkPassNum) {
                        msg = '确定存档该合同信息?'
                    } else {
                        msg = '还有校对未通过的发票信息，请确认是否存档合同。'
                    }
                    sweetalert.confirm('操作提醒', msg).then(() => {
                        httpRequest.post_submitContract(item).then(() => {
                            logger.logSuccess('提交成功')
                            $scope.queryList()
                        })
                    })
                },
            },
            {
                label: '删除',
                handler(item) {
                    sweetalert.confirm('删除提醒', '是否删除该条合同记录?').then(() => {
                        httpRequest.get_deleteContractAndInvoice(item.contractId).then(() => {
                            logger.logSuccess('删除成功')
                            $scope.queryList()
                        })
                    })
                },
            },
        ]
    }
}
ListCtrl.$inject = ['$scope', 'httpRequest', 'logger', '$state', 'sweetalert', '$uibModal']



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractEntering/listCtrl.js